import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const typography = [
  "txt-compact-xsmall",
  "txt-compact-xsmall-plus",
  "txt-compact-small",
  "txt-compact-small-plus",
  "txt-compact-medium",
  "txt-compact-medium-plus",
  "txt-compact-large",
  "txt-compact-large-plus",
  "txt-compact-xlarge",
  "txt-compact-xlarge-plus",
  "txt-xsmall",
  "txt-xsmall-plus",
  "txt-small",
  "txt-small-plus",
  "txt-medium",
  "txt-medium-plus",
  "txt-large",
  "txt-large-plus",
  "txt-xlarge",
  "txt-xlarge-plus",
  "h1-core",
  "h2-core",
  "h3-core",
  "h1-display",
  "h2-display",
  "h3-display",
  "h4-display",
  "lead",
  "code-label",
];

const shadows = [
  "borders-base",
  "borders-error",
  "borders-focus",
  "borders-interactive-with-active",
  "borders-interactive-with-focus",
  "borders-interactive-with-shadow",
  "buttons-danger",
  "buttons-danger-focus",
  "buttons-inverted",
  "buttons-inverted-focus",
  "buttons-neutral",
  "buttons-neutral-focus",
  "details-contrast-on-bg-interactive",
  "details-switch-background",
  "details-switch-background-focus",
  "details-switch-handle",
  "elevation-card-hover",
  "elevation-card-rest",
  "elevation-code-block",
  "elevation-commandbar",
  "elevation-flyout",
  "elevation-modal",
  "elevation-tooltip",
];

// Teach tailwind-merge our custom utilities, so a later `txt-*` or `shadow-*`
// passed through `className` replaces the component's default instead of
// sitting beside it and losing on stylesheet order.
const twMerge = extendTailwindMerge<"typography">({
  extend: {
    theme: { shadow: shadows },
    classGroups: { typography: typography },
  },
});

/** Joins class names, letting later Tailwind classes win over earlier ones. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
